import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';
import * as React from 'react';

import { cn } from './utils';

export type CheckboxState = React.ComponentPropsWithoutRef<
  typeof CheckboxPrimitive.Root
>['checked'];

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, disabled, checked, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-sm border-[1.5px] border-grey-60 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-paper data-[state=checked]:border-primary flex justify-center items-center',
      'disabled:bg-grey-5 disabled:border-grey-20 data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-paper data-[state=indeterminate]:border-primary',
      checked && disabled
        ? 'disabled:bg-grey-60 disabled:border-grey-60 data-[state=checked]:bg-grey-60 data-[state=checked]:border-grey-60'
        : '',
      className,
    )}
    disabled={disabled}
    checked={checked}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn('flex items-center justify-center text-current')}
    >
      {checked === 'indeterminate' && <Minus className="h-4 w-4" />}
      {checked !== 'indeterminate' && <Check className="h-4 w-4" />}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
